import { Select as KobalteSelect } from "@kobalte/core/select"
import type { AccentHue } from "@repo/fika-design-system/color"
import type { Accessor } from "solid-js"
import { Icon } from "@/designSystem/components/icon"
import {
  selectClass,
  selectContentClass,
  selectIconClass,
  selectItemIndicatorClass,
  selectItemRecipe,
  selectLabelClass,
  selectListboxClass,
  selectTriggerRecipe,
  selectValueClass,
} from "./select.css"

interface Option {
  value: string | null
  label: string
  disabled: boolean
}

type SelectProps = {
  options: Option[]
  label: string
  placeholder?: string
  value: Accessor<string | null>
  onChange: (value: string | null) => void
  hue: AccentHue
}
export function Select(props: SelectProps) {
  return (
    <KobalteSelect<Option>
      value={props.options.find(option => option.value === props.value())}
      options={props.options}
      onChange={value => props.onChange(value?.value ?? null)}
      placeholder={props.placeholder}
      optionValue="value"
      optionTextValue="label"
      optionDisabled="disabled"
      class={selectClass}
      itemComponent={itemProps => (
        <KobalteSelect.Item
          item={itemProps.item}
          class={selectItemRecipe({ hue: props.hue })}
        >
          <KobalteSelect.ItemLabel>
            {itemProps.item.rawValue.label}
          </KobalteSelect.ItemLabel>
          <KobalteSelect.ItemIndicator class={selectItemIndicatorClass}>
            <Icon size="18" name="check" />
          </KobalteSelect.ItemIndicator>
        </KobalteSelect.Item>
      )}
    >
      <KobalteSelect.Label as="label" class={selectLabelClass}>
        {props.label}
      </KobalteSelect.Label>
      <KobalteSelect.Trigger
        class={selectTriggerRecipe({ hue: props.hue })}
        aria-label="Fruit"
      >
        <KobalteSelect.Value<Option> class={selectValueClass}>
          {state => state.selectedOption().label}
        </KobalteSelect.Value>
        <KobalteSelect.Icon class={selectIconClass}>
          <Icon name="chevrons-up-down" size="18" />
        </KobalteSelect.Icon>
      </KobalteSelect.Trigger>
      <KobalteSelect.Portal>
        <KobalteSelect.Content class={selectContentClass}>
          <KobalteSelect.Listbox class={selectListboxClass} />
        </KobalteSelect.Content>
      </KobalteSelect.Portal>
    </KobalteSelect>
  )
}
